
export default [
  {
    path: "corpWebsite",
    component: () => import("@/views/modules/corpWebsite/index"),
    meta: { title: "企业站", needToken: true },
    children: [
      {
        path: "agreedGoods",
        name: "corpWebsite-agreedGoods",
        component: () => import("@/views/modules/corpWebsite/agreedGoods"),
        meta: { title: "协议商品", needToken: true },
      },
      {
        path: "boughtGoods",
        name: "corpWebsite-boughtGoods",
        component: () => import("@/views/modules/corpWebsite/boughtGoods"),
        meta: { title: "常购商品", needToken: true },
      },
      {
        path: "groupAgreedGoods",
        name: "corpWebsite-groupAgreedGoods",
        component: () => import("@/views/modules/corpWebsite/groupAgreedGoods"),
        meta: { title: "集团协议商品", needToken: true },
      },
      {
        path: "browseHistory",
        name: "corpWebsite-browseHistory",
        component: () =>
          import("@/views/modules/corpWebsite/browseHistory/browseHistory"),
        meta: { title: "浏览历史", needToken: true },
      },
      {
        path: "myShopCart",
        name: "corpWebsite-myShopCart",
        component: () =>
          import("@/views/modules/corpWebsite/myShopCart/index"),
        meta: { title: "购物车", needToken: true },
      }
    ],
  },
];
